import React from 'react'
import type { PropsWithChildren } from 'react'

import { useJoinToSpeakAsHost } from '../../../../join-to-speak'
import { BadgeComponent } from '../../../../components/BadgeComponent/BadgeComponent'

type JoinToSpeakBadgeProps = PropsWithChildren<{
  color: string
}>

type JoinToSpeakBadgeFeatureProps = {
  isEnabled?: boolean
} & JoinToSpeakBadgeProps

const JoinToSpeakBadge = ({ color, children }: JoinToSpeakBadgeProps) => {
  const { requests } = useJoinToSpeakAsHost()

  return (
    <BadgeComponent count={requests.length} color={color}>
      {children}
    </BadgeComponent>
  )
}

const JoinToSpeakBadgeFeature = ({
  isEnabled = false,
  color,
  children,
}: JoinToSpeakBadgeFeatureProps) => {
  if (!isEnabled) {
    return <>{children}</>
  }

  return <JoinToSpeakBadge color={color}>{children}</JoinToSpeakBadge>
}

export { JoinToSpeakBadgeFeature, JoinToSpeakBadge }
